import { Entities } from '@inwink/entities/entities';
import { getEventEntityDataSource } from '../modules/event/api/index';
import { IDataSourceV3Options, IDataSourceV3 } from './base/datasource';

export function filesDataSourceV3(eventid: string, options?: IDataSourceV3Options): IDataSourceV3<Entities.IDocument> {
    return getEventEntityDataSource<Entities.IDocument>(eventid, 'file', 'file', options);
}
